import { useRef } from 'react'
import { useModalDialog } from '../../../hooks'
import { EditDatesForm } from '../forms'

export const useBuddyDialog = () => {

  const { showModalDialog } = useModalDialog()
  const editDatesRef = useRef()

  const showDeleteDialog = (count, onSubmit) => {
    const config = {
      title: count > 1 ? `Ta bort ${count} rundor` : "Ta bort runda",
      Content: () => <div>{count > 1 ? `De ${count} valda rundorna` : 'Rundan'} flyttas till papperskorgen och kan återställas innan de rensas bort permanent.</div>,
      submitLabel: "Ta bort",
      submitLabelLoading: "Tar bort...",
      cancelLabel: "Avbryt",
      onSubmit,
    }
    showModalDialog(config)
  }

  const showDeleteAllDialog = (onSubmit) => {
    const config = {
      title: "Ta bort all historik",
      Content: () => <div>Alla aktiva rundor flyttas till papperskorgen och kan återställas innan de rensas bort permanent.</div>,
      submitLabel: "Ta bort allt",
      submitLabelLoading: "Tar bort...",
      cancelLabel: "Avbryt",
      onSubmit,
    }
    showModalDialog(config)
  }

  // round: the generation object being edited (needs generation_timestamp
  // and round_end_timestamp to pre-fill the form). onSubmit receives
  // { generationTimestamp, roundEndTimestamp } and must call
  // hideModalDialog() itself once done.
  const showEditDatesDialog = (round, onSubmit) => {
    const config = {
      title: "Ändra datum",
      Content: EditDatesForm,
      contentProps: { data: round, submitForm: onSubmit, ref: editDatesRef },
      onSubmit: () => editDatesRef.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true })),
      submitLabel: "Spara",
      submitLabelLoading: "Sparar...",
      cancelLabel: "Avbryt",
    }
    showModalDialog(config)
  }

  return {
    showDeleteDialog,
    showDeleteAllDialog,
    showEditDatesDialog,
  }
}
